export default __webpack_public_path__ + "23ff9e1240cf7b709dd411c49b394c80.png";